module.exports = __webpack_public_path__ + "media/cgae/bghead-9aab9076.png";